'use client'

import { Event, Meta } from '@/types'
import EventCard from '@/components/EventCard'
import React from 'react'
import LoadMore from '@/app/web/events/ui/LoadMore'

const EmptyState = () => (
  <div className="flex flex-col w-full h-full items-center text-center">
    <span className="text-gray-900 text-lg font-semibold">
      No hackathons here - yet 👀
    </span>
    <p className="max-w-md text-gray-500">
      There are no hackathons matching your search or filter options, but stay
      tuned or try another search!
    </p>
  </div>
)

interface EventListProps {
  events: Event[]
  state?: string
  pagy?: Meta
  isExpand?: boolean
}

export default function EventList({
  events,
  state,
  pagy,
  isExpand,
}: EventListProps) {
  return (
    <>
      <div className="w-full flex flex-col gap-6">
        {events && events.length ? (
          <>
            <div
              // Three cards only from xl: at md the same three left each card
              // ~130px wide and the content inside them was cut off.
              className={`grid grid-cols-1 ${
                isExpand ? 'sm:grid-cols-2 xl:grid-cols-3' : 'lg:grid-cols-2'
              } gap-6`}
            >
              {events.map((event: Event, index) => (
                <EventCard
                  state={state || 'register_now'}
                  key={index}
                  eventData={event}
                />
              ))}
            </div>
            {pagy && (
              <div className="w-full text-center">
                {pagy.page < pagy.pages && <LoadMore totalPages={pagy.pages} />}
              </div>
            )}
          </>
        ) : (
          <EmptyState />
        )}
      </div>
    </>
  )
}
